export const SmSessionKeys = {
  // --- Navigation & Filters ---
  LAST_SCROLL: 'lastScroll',
  IS_DRILL_DOWN: 'isDrillDown',
  FROM_DATE: 'fromDatePicker',
  TO_DATE: 'toDatePicker',
  UNSCHEDULED: 'unscheduled',
  SORT_VALUE: 'sortValue',
  SEARCH_TEXT: 'searchText',
  PREVIOUS_SM: 'previousSM',
  RELOAD_DASH: 'reloadDash',
  STAY_SERVICE_DETAILS: 'stayServiceDetails',

  // --- Work Order Data ---
  CURRENT_WORK_ORDER: 'currentWorkOrder',
  CURRENT_SCOPE: 'currentScope',
  CURRENT_TECHNICIAN: 'currentTechnician',

  // --- Dashboard Communication ---
  DASH_TO_MANAGE_ID: 'SMWODashToManID',
  DASH_TO_MANAGE_TRIP: 'SMWODashToManIDWithTrip',

  // --- Dashboard State ---
  DASH_START_DATE: 'SMWODFDate',
  DASH_END_DATE: 'SMWODTDate',
  DASH_SEARCH: 'SMWODSearch',
  DASH_INCLUDE_CLOSED: 'SMWOIncludeClosed',
  DASH_UNSENT_ONLY: 'SMWOUnsentTripsOnly',
  DASH_UNAVAILABLE_TIME: 'SMWOIncludeUnavailableTime',
  DASH_FILTERS: 'SMWODFilters',
} as const;
